import { render, staticRenderFns } from "./PackageFormatForm.vue?vue&type=template&id=b304b892&scoped=true&lang=html&"
import script from "./PackageFormatForm.vue?vue&type=script&lang=js&"
export * from "./PackageFormatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b304b892",
  null
  
)

export default component.exports